/*
 * @Author: Dong
 * @Date: 2022-04-07 17:06:29
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-16 13:11:42
 */
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { Button, message, Spin } from 'sup-ui';
import List from './List';
import { fileConfig } from 'root/store/actions';
import messages from './messages';
import styles from './index.less';
import { SelectedVersionType } from './types';
import { deletePackApi, getExtendPackage } from 'root/services/packageManage';
import { packForms } from 'root/services/manager';

import { useDispatch, useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';

interface PropsType {
  uploadQueueChange: (x: SelectedVersionType) => void;
  type: string;
  catalog?: string;
}

const SelectPackage = (props: PropsType, ref: React.Ref<unknown> | undefined) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { catalog, uploadQueueChange, type } = props;
  const { tab, selectedVersions } = useSelector((state: reducerStates) => state.fileConfig);

  const uploadRequestSource = useRef<any>(null);
  const uploadFileRef = useRef<any>(null);

  const [dataSource, setDataSource] = useState<any>([]);
  const { queueState } = useSelector((state: any) => state.uploadFile);
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    validateFields: validateFields, // 校验表单数据
    getReadyInstallData: getReadyInstallData, // 父组件点击安装，提交数据给父组件
    clearData: clearData, // 关闭弹框，清空redux数据
  }));

  useEffect(() => {
    getCompleteData();
    initPackForms();
  }, []);

  // 上传队列发生变化,回调
  useEffect(() => {
    uploadQueueChange(selectedVersions);
  }, [queueState.queue, selectedVersions, tab]);

  // 重置redux数据
  const clearData = () => {
    cancelTask();
    dispatch(fileConfig.clearData());
  };

  // 取消任务
  const cancelTask = () => {
    if (!uploadRequestSource.current?.cancel) return;
    uploadRequestSource.current.cancel();
  };

  // 获取当前选择的数据
  const getReadyInstallData = () => {
    return selectedVersions;
  };
  // 重试
  const handleRetry = (data: any) => {
    uploadFileRef?.current.handleRetry(data);
  };
  // 校验表单数据
  const validateFields = () => {};

  //  获取已经上传完成的数据
  const getCompleteData = () => {
    const params = {
      catalog,
      archiveId: '',
      requestType: type === 'install' ? '1' : '2',
    };
    setLoading(true);
    getExtendPackage(params)
      .then((res) => {
        const { data = [] } = res;
        setDataSource(data);
        const updateMethodList: any = [];
        data.forEach((item: any) => {
          item?.specifics?.forEach((ele: any) => {
            const { updateMethod, archiveId, affectBusiness, packageConf } = ele;
            updateMethodList.push({ name: item.name, archiveId, updateMethod, affectBusiness, packageConf });
          });
        });
        dispatch(fileConfig.setUpdateMethod(updateMethodList));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 选择版本
  const changeSelect = (id: string, name: string) => {
    dispatch(fileConfig.selectVersion({ [name]: id }));
  };

  // 取消正在上传中的包
  const cancelUpload = (name: string, version: string) => {
    uploadFileRef?.current.deleteTask(name, version);
    setDataSource(dataSource.filter((item: any) => item.name !== name && item.version !== version));
  };

  // 删除安装包
  const handleDelete = (packageName: string) => {
    deletePackApi(packageName).then(() => {
      message.success('删除成功');
      setDataSource(dataSource.filter((item: any) => item.fileName !== packageName));
    });
  };

  // 获取安装包表单配置默认值
  const initPackForms = () => {
    packForms().then((res) => {
      const { data } = res;
      if (!data || !data.config) return;
      dispatch(fileConfig.changeForm(data.config));
    });
  };

  return (
    <div className={styles.container}>
      <Spin spinning={loading}>
        <div className={styles.installPath}>
          <div className={styles.installPathRight}>
            <Button className={styles.refreshBtn} onClick={getCompleteData}>
              {intl.formatMessage(messages.refresh)}
            </Button>
          </div>
        </div>
        {dataSource.length ? (
          <div className={styles.listBox}>
            <List
              dataSource={dataSource}
              uploadQueue={queueState.queue}
              type={tab}
              selectedVersions={selectedVersions}
              changeSelect={changeSelect}
              cancelUpload={cancelUpload}
              deleteTask={handleDelete}
              handleRetry={handleRetry}
              operationType={type}
            />
          </div>
        ) : (
          <div className={styles.null}> {intl.formatMessage(messages.null)}</div>
        )}
      </Spin>
    </div>
  );
};

export default forwardRef(SelectPackage);
